import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/**
 * A lightweight help component that displays a question mark icon
 * and shows a tooltip with the provided text when hovered or clicked.
 *
 * Usage:
 * <Help text="This text will pop up when the question mark is hovered over." />
 */
const Help = ({
  text,
  placement = 'top-start',
  iconProps = { fontSize: 'small' },
  tooltipProps = {},
  buttonProps = { size: 'small' }
}) => {
  if (!text) return null;
  return (
    <Tooltip
      title={text}
      placement={placement}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={2500}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'rgba(29,40,44,0.98)', // Example: change background color
            color: 'white',              // Example: change text color
            borderRadius: '10px',
            fontFamily: 'Helvetica',
            fontWeight: '600',
            border: '2px solid rgb(148, 207, 236)',
            fontSize: '.9rem',        // Example: set font size (you can use '1rem', '14px', etc.)
            '& .MuiTooltip-arrow': {    // Style the arrow to match
              color: 'primary.main',
            },
          },
        },
      }}
      {...tooltipProps} // Spread any additional tooltip props
    >
      <IconButton
        color="inherit"
        aria-label="help"
        {...buttonProps}
      >
        <HelpOutlineIcon {...iconProps} />
      </IconButton>
    </Tooltip>
  );
};

export default Help;